import axios from "axios";
import { fileToApiFormat } from "../utils/FormUtil";
const baseUrl = process.env.REACT_APP_GATEWAY_URL;

export const GetRacePet = async (userToken) =>
  await axios.get(`${baseUrl}/services/parametrics/api/race`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

export const GetRacePetBySpecieId = async (specieId, userToken) =>
  await axios.get(`${baseUrl}/services/parametrics/api/race/${specieId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

export const GetSpeciesPet = async (userToken) =>
  await axios.get(`${baseUrl}/services/parametrics/api/species`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

export const GetVaccinesBySpecieId = async (specieId, userToken) =>
  await axios.get(`${baseUrl}/services/parametrics/api/vaccines/${specieId}`, {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });

export const GetPetsByPatientId = async (patientId, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patients/get-family/${patientId}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetPetsByWithPlanPatientId = async (patientId, userToken) =>
  await axios.get(
    `${baseUrl}/services/parametrics/api/patient-financer-plans/fam-members/${patientId}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const CreatePetAsync = async (id, data, userToken) =>
  await axios.post(
    `${baseUrl}/services/userprofile/api/patients/add-family-member/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetPetImages = async (id, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patients/family-member/get-photos?familyMemberId=${id}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetStudiesMedical = async (id, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patient/member/study/${id}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetHealthBooklet = async (id, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patient/member/sanitary-record/${id}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetMedicalStudiesOnlyNames = async (idFamiliar, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patient/member/study/simplified/${idFamiliar}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetMedicalStudyById = async (fileId, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patient/member/study/file/${fileId}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetSanitariesRecordOnlyNames = async (idFamiliar, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patient/member/sanitary-record/simplified/${idFamiliar}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const GetSanitaryRecordById = async (fileId, userToken) =>
  await axios.get(
    `${baseUrl}/services/userprofile/api/patient/member/sanitary-record/file/${fileId}`,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );

export const SaveStudiesMedicalHistory = async (id, files, userToken) => {
  const formattedFiles = await Promise.all(
    Array.from(files).map((file) => fileToApiFormat(file))
  );
  return await axios.put(
    `${baseUrl}/services/userprofile/api/patient/member/study/${id}`,
    formattedFiles,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};

export const SaveHealthBooklet = async (id, files, userToken) => {
  const formattedFiles = await Promise.all(
    Array.from(files).map((file) => fileToApiFormat(file))
  );
  return await axios.put(
    `${baseUrl}/services/userprofile/api/patient/member/sanitary-record/${id}`,
    formattedFiles,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};

export const UpdatePetAsync = async (id, data, userToken) =>
  await axios.put(
    `${baseUrl}/services/userprofile/api/patients/edit-family-member/${id}`,
    data,
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
